import { render, staticRenderFns } from "./UserActionsWrap.vue?vue&type=template&id=d84c8eda&scoped=true&"
import script from "./UserActionsWrap.vue?vue&type=script&lang=js&"
export * from "./UserActionsWrap.vue?vue&type=script&lang=js&"
import style0 from "./UserActionsWrap.vue?vue&type=style&index=0&id=d84c8eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84c8eda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/var/www/nmg-charitychallenge.com/charity-challenge/frontbuild/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VFlex,VLayout})
